import { render, staticRenderFns } from "./MenuRef.vue?vue&type=template&id=1f8e3c30&scoped=true"
import script from "./MenuRef.vue?vue&type=script&lang=js"
export * from "./MenuRef.vue?vue&type=script&lang=js"
import style0 from "./MenuRef.vue?vue&type=style&index=0&id=1f8e3c30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8e3c30",
  null
  
)

export default component.exports